import {API} from "../../backend";

export const getRoles = (userId, token) => {
  return fetch(`${API}/roles/${userId}`,{
      method: "GET",
      headers:{
        Accept: "application/json",
        Authorization: `Bearer ${token}`
    },
  })
  .then(response => {
      return response.json();
  })
  .catch(err => { console.error(err); return { error: true, message: err?.message }; })
}
